import styled from 'styled-components';

export const VariableDropdownContainer = styled.div`
  min-width: 225px;
  max-height: 200px;
  overflow: auto;
  box-shadow: ${props => props.showVariableList ? '0 0 0 1px rgba(14, 19, 24, 0.07), 0 2px 12px rgba(14, 19, 24, 0.2)' : ''};
  .ant-menu-item {
    background-color: #ffffff !important;
    &:hover {
      background-color: rgba(14, 19, 24, 0.07) !important;
      color: #0e1318;
    }
  }
  .variable-type {
    color: #fff;
    font-size: 10px;
    background: #b1272c;
    border-radius: 30px;
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const CustomLogicPopupContainer = styled.div`
  margin-top:4px;
  width: ${props => props.isTextBox ? '350px' : '275px'};
  max-height: 200px;
  overflow: unset;
  box-shadow: ${props => props.showVariableList ? '0 0 0 1px rgba(14, 19, 24, 0.07), 0 2px 12px rgba(14, 19, 24, 0.2)' : ''}; 

  .ant-menu-vertical > .ant-menu-item {
    height: 20px;
    line-height: 20px;
  }

  .ant-menu-vertical > .ant-menu-item:hover,
  .ant-menu-item.logic-hover {
    height: 40px;
    line-height: 20px;
    transition: all 0.5s ease;
  }

  .logic_function_item{
    display: flex;
    flex-direction: column;
    color: #8F57FF;

    .logic_description{
      margin-left: 20px;
      font-size: 12px;
    }
  }
  .custom-logic-editor {
    .ql-container {
      border: 1px solid #333;
      border-radius: 6px;
      height: 50px;
      .ql-editor {
        overflow: auto !important;
      }
    }
  }
`;
